import { defineMessages } from 'react-intl';

// Mensagens i18n para o extensor de schema base (placeholder).
const messages = defineMessages({
  field_placeholder: {
    id: 'form_field_placeholder',
    defaultMessage: 'Placeholder',
  },
  field_placeholder_description: {
    id: 'form_field_placeholder_description',
    defaultMessage: 'Example text displayed in the field when it is empty.',
  },
});

/**
 * Base schema extender that provides a `placeholder` property.
 */
export const BaseSchemaExtender = (intl) => {
  return {
    fields: ['placeholder'],
    properties: {
      placeholder: {
        title: intl.formatMessage(messages.field_placeholder),
        description: intl.formatMessage(messages.field_placeholder_description),
        type: 'string',
      },
    },
    required: [],
  };
};

export default BaseSchemaExtender;
